<template>
  <v-navigation-drawer
    app
    :temporary="isSmall"
    :permanent="!isSmall"
    :expand-on-hover="!isSmall"
    :mini-variant.sync="mini"
    v-model="localValue"
    width="320"
    class="parent-list-overflow"
  >
    <div class="list-overflow">
      <v-list-item class="pl-2">
        <v-avatar color="orange" size="40" class="mr-2">
          <v-img src="../../assets/default-user.png"/>
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">
            <strong v-if="user">{{ user.nome }}</strong>
          </v-list-item-title>
          <v-list-item-subtitle>
            Bem-vindo!
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>

      <v-list dense>
        <v-list-item
          target="_blank"
          active-class="orange--text"
          @click="openMarketplace"
        >
          <v-list-item-icon>
            <v-icon>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold body-2">Marketplace</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon>mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list dense>
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandIndicadores"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-chart-areaspline</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">Indicadores</v-list-item-title>
          </template>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasModuleGestorFrete
              && !hasRoleRequisicao && !hasRoleObservadorGestao"
            to="/meu-painel"
          >
            <v-list-item-icon>
              <v-icon>mdi-monitor-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Meu painel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            :class="groupItemClass"
            to="/dashboard"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Dashboard</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            :class="groupItemClass"
            to="/indicadores-compras"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Indicadores de compras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            v-if="hasModuleGestorFrete && hasRoleObservadorGestao"
            :class="groupItemClass"
            to="/dashboard-frete"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Indicadores de frete</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/indicador-fornecedores"
          >
            <v-list-item-icon>
              <v-icon>mdi-factory</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      <v-list dense>
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-shopping-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Gestão de compras</v-list-item-title>
          </template>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleRequisicao && !this.hasRoleObservadorGestao"
            to="/requisicoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-up</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Solicitações de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasRoleAprovador && !hasModuleGerencia"
            to="/aprovacoes-solicitacoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Aprovações de solicitações
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            active-class="orange--text"
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/cotacoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Cotações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasRoleAprovador && !hasModuleGerencia && !hasRoleObservadorGestao"
            active-class="orange--text"
            to="/aprovacoes"
          >
            <v-list-item-icon>
              <v-icon>mdi-check-circle-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Aprovações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleAprovador && !hasRoleObservadorGestao"
            active-class="orange--text"
            to="/compras"
          >
            <v-list-item-icon>
              <v-icon>mdi-shopping</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Compras</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="hasControleEntrega"
            link
            :class="groupItemClass"
            :disabled="!hasRoleGestorEntrega && !hasRoleObservadorGestao"
            active-class="orange--text"
            to="/gesta-entregas"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Entregas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list dense v-if="hasModuleGestorFrete">
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-truck</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Gestão de frete
            </v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGestorFrete && !hasRoleObservadorGestao"
            to="/cotacoes-fretes"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-fast</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Cotações de fretes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :disabled="!hasModuleGestorFrete && !hasRoleObservadorGestao"
            :class="groupItemClass"
            to="/contratacoes-fretes"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-truck-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Contratações de fretes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list dense >
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandFornecedores"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-account-supervisor-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">
              Gestão de fornecedores
            </v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerenciaOrCompraConjunta && !hasRoleObservadorGestao"
            to="/fornecedores"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-account-check-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Fornecedores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list dense >
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandProdutos"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-package-variant-closed</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">Produtos</v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            to="/categorias"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-view-grid</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Categorias</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            to="/produtos"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Meus produtos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            to="/unidades-medidas"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-beaker-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Unidades de Medida</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list dense>
        <v-list-group
          active-class="grey--text text--darken-2"
          value="true"
          v-model="expandMinhaEmpresa"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-office-building</v-icon>
            </v-list-item-icon>
            <v-list-item-title dense class="font-weight-bold body-2">Empresa</v-list-item-title>
          </template>
          <v-list-item
            link
            :class="groupItemClass"
            to="/minha-empresa"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Minha empresa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/modos-pagamento"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-cash-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Modos de pagamento</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="(!hasModuleGerencia || !hasRoleGestorCompras) && !hasRoleObservadorGestao"
            to="/centros-custo"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-puzzle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Centros de custo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="(!hasModuleGerencia || !hasRoleGestorCompras) && !hasRoleObservadorGestao"
            to="/projetos"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-folder-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Projetos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/configuracoes-aprovacao"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Alçadas de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="false"
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/alcadas-compra"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Alçadas de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/alcadas-solicitacao"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-tune</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Alçadas de solicitação</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia"
            to="/tabelas-preco"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-table</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Tabelas de preço</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao"
            to="/configuracoes-nota-entrada"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-invoice-list-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Notas de Entrada</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia && !hasRoleObservadorGestao && !hasRoleRequisicao"
            to="/mensagens"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-message-text-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                Mensagens personalizadas
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasModuleGerencia"
            to="/configuracoes-moedas"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-currency-usd</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Moedas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :class="groupItemClass"
            :disabled="!hasIntegracaoAtiva || !hasModuleGerencia"
            to="/integracao"
            active-class="orange--text"
          >
            <v-list-item-icon>
              <v-icon>mdi-connection</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">Integração</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';

const marketplaceUrl = process.env.VUE_APP_MARKETPLACE_URL;

export default {
  props: ['value'],
  data() {
    return {
      mini: true,
      expandIndicadores: false,
      expandFornecedores: false,
      expandMinhaEmpresa: false,
      expandProdutos: false,
      marketplaceUrl,
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'hasModuleGerencia', 'hasModuleCompraConjunta', 'hasModuleGerenciaOrCompraConjunta', 'hasModuleGestorFrete', 'hasRoleRequisicao', 'hasRoleAprovador', 'hasControleEntrega', 'hasIntegracaoAtiva', 'hasRoleGestorCompras', 'hasRoleObservadorGestao', 'hasRoleGestorEntrega', 'hasRoleCadastroProduto']),
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    groupItemClass() {
      return this.mini ? '' : 'group-item';
    },
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    miniComputed: {
      get() {
        return this.isSmall;
      },
    },
  },
  methods: {
    openMarketplace() {
      window.open(`${this.marketplaceUrl}`, '_blank');
    },
  },
  created() {
    if (this.isSmall) {
      this.mini = false;
    }
  },
};
</script>

<style scoped>
.group-item {
  padding-left: 30px !important;
}

.parent-list-overflow {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.list-overflow {
  width: 100%;
  height: 100%;
  padding-right: 17px;
  overflow-y: scroll;
  box-sizing: content-box;
}
</style>
